export default import.meta.ROLLUP_FILE_URL_e0sU936YnzWsgPg0o8Ww1A